import * as React from 'react';
import {Redirect, Router, Switch} from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import AuthLayout from './components/AuthLayout';
import GlobalLayout from './components/GlobalLayout';
import AllChat from './pages/AllChat';
import AnaChannel from './pages/AnaChannel';
import AnaChat from './pages/AnaChat';
import ChangePwd from './pages/ChangePassword';
import Channel from './pages/Channel';
import CohostClubChannel from './pages/CohostClubChannel';
import CohostClubChat from './pages/CohostClubChat';
import ConnectAirbnb from './pages/ConnectListings/ConnectAirbnb';
import SelectAirbnbListings from './pages/ConnectListings/ConnectAirbnb/SelectAirbnbListings';
import CreatePromoteListing from './pages/CreatePromoteListing';
import CreateTeam from './pages/CreateTeam/CreateTeam';
import EditPromoteListing from './pages/EditPromoteListing';
import EditTeam from './pages/EditTeam';
import EditUser from './pages/EditUser';
import ForgotPwd from './pages/ForgotPassword';
import IntegrationInstructions from './pages/IntegrationInstructions';
import ListingDetail from './pages/ListingDetail';
import ListingInfos from './pages/ListingInfos';
import LongTermListings from './pages/Listings';
import Login from './pages/Login';
import LongTermListingDetail from './pages/LongTermListingDetail';
import MailingList from './pages/MailingList';
import Register from './pages/Register';
import RegisterCohost from './pages/RegisterCohost';
import Reservations from './pages/Reservations';
import ResetPwd from './pages/ResetPassword';
import TeamDetail from './pages/TeamDetail';
import TeamInvite from './pages/TeamInvite';
import Teams from './pages/Teams';
import UserDetail from './pages/UserDetail';
import Users from './pages/Users';
import Welcome from './pages/Welcome';
import {history} from './StateProvider/StateProvider';

export default class App extends React.Component<{}, {}> {
  public render() {
    return (
      <Router history={history}>
        <Switch>
          <GlobalLayout
            path="/"
            children={
              <AuthGuard
                authorizedComponent={Welcome}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
            exact={true}
          />

          <GlobalLayout
            path="/change_password"
            children={
              <AuthGuard
                authorizedComponent={ChangePwd}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
          />
          <GlobalLayout
            path="/messages"
            children={
              <AuthGuard
                authorizedComponent={AllChat}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
            exact={true}
          />
          <GlobalLayout
            path="/messages/:channelKind/:channelId"
            children={
              <AuthGuard
                authorizedComponent={Channel}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
          />
          <GlobalLayout
            path="/ana-messages"
            children={
              <AuthGuard
                authorizedComponent={AnaChat}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
            exact={true}
          />
          <GlobalLayout
            path="/ana-messages/:channelKind/:channelId"
            children={
              <AuthGuard
                authorizedComponent={AnaChannel}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
          />
          <GlobalLayout
            path="/cohost-club-messages"
            children={
              <AuthGuard
                authorizedComponent={CohostClubChat}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
            exact={true}
          />
          <GlobalLayout
            path="/cohost-club-messages/:channelKind/:channelId"
            children={
              <AuthGuard
                authorizedComponent={CohostClubChannel}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
            exact={true}
          />
          <GlobalLayout
            path="/connect/airbnb"
            children={
              <AuthGuard
                authorizedComponent={ConnectAirbnb}
                unauthorizedComponent={<Redirect to="/login" />}
              />
              // tslint:disable
            }
          />
          <GlobalLayout
            path="/import_listings"
            children={
              <AuthGuard
                authorizedComponent={SelectAirbnbListings}
                unauthorizedComponent={<Redirect to="/login" />}
              />
              // tslint:disable-next-line:jsx-curly-spacing
            }
          />
          <GlobalLayout
            path="/onboarding/tour/:listingsProvider"
            children={
              <AuthGuard
                authorizedComponent={IntegrationInstructions}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
          />
          <GlobalLayout
            path="/reservations"
            children={
              <AuthGuard
                authorizedComponent={Reservations}
                unauthorizedComponent={<Redirect to="/login" />}
              />
              // tslint:disable-next-line:jsx-curly-spacing
            }
          />

          <GlobalLayout
            path="/long-term-listings/:listingId"
            children={
              <AuthGuard
                authorizedComponent={LongTermListingDetail}
                unauthorizedComponent={<Redirect to="/login" />}
              />
              // tslint:disable-next-line:jsx-curly-spacing
            }
          />

          <GlobalLayout
            path="/long-term-listings"
            children={
              <AuthGuard
                authorizedComponent={LongTermListings}
                unauthorizedComponent={<Redirect to="/login" />}
              />
              // tslint:disable-next-line:jsx-curly-spacing
            }
          />

          <GlobalLayout
            path="/teams/new"
            children={
              <AuthGuard
                authorizedComponent={CreateTeam}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
          />
          <GlobalLayout
            path="/invite"
            children={
              <AuthGuard
                authorizedComponent={TeamInvite}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
          />
          <GlobalLayout
            path="/mailing_list"
            children={
              <AuthGuard
                authorizedComponent={MailingList}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
          />
          <GlobalLayout
            path="/listing-infos"
            children={
              <AuthGuard
                authorizedComponent={ListingInfos}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
          />
          <GlobalLayout
            path="/teams"
            children={
              <AuthGuard
                authorizedComponent={Teams}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
            exact={true}
          />
          <GlobalLayout
            path="/users"
            children={
              <AuthGuard
                authorizedComponent={Users}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
            exact={true}
          />
          <GlobalLayout
            path="/users/:userId"
            children={
              <AuthGuard
                authorizedComponent={UserDetail}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
            exact={true}
          />
          <GlobalLayout
            path="/users/:userId/edit"
            children={
              <AuthGuard
                authorizedComponent={EditUser}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
            exact={true}
          />
          <GlobalLayout
            path="/teams/:teamId"
            children={
              <AuthGuard
                authorizedComponent={TeamDetail}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
            exact={true}
          />
          <GlobalLayout
            path="/teams/:teamId/edit"
            children={
              <AuthGuard
                authorizedComponent={EditTeam}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
            exact={true}
          />
          <GlobalLayout
            path="/listings/:listingId"
            children={
              <AuthGuard
                authorizedComponent={ListingDetail}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
            exact={true}
          />
          <GlobalLayout
            path="/users/:userId/promote-listings"
            children={
              <AuthGuard
                authorizedComponent={CreatePromoteListing}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
            exact={true}
          />
          <GlobalLayout
            path="/users/:userId/promote-listings/:listingId/edit"
            children={
              <AuthGuard
                authorizedComponent={EditPromoteListing}
                unauthorizedComponent={<Redirect to="/login" />}
              />
            }
            exact={true}
          />
          <AuthLayout
            path="/register"
            children={
              <AuthGuard
                unauthorizedComponent={Register}
                authorizedComponent={<Redirect to="/" />}
              />
            }
          />
          <AuthLayout
            path="/register_cohost"
            children={
              <AuthGuard
                unauthorizedComponent={RegisterCohost}
                authorizedComponent={<Redirect to="/" />}
              />
            }
          />
          <AuthLayout
            path="/login"
            children={
              <AuthGuard
                unauthorizedComponent={Login}
                authorizedComponent={<Redirect to="/" />}
              />
            }
          />
          <AuthLayout
            path="/forgot_password"
            children={
              <AuthGuard
                unauthorizedComponent={ForgotPwd}
                authorizedComponent={<Redirect to="/" />}
              />
            }
          />
          <AuthLayout
            path="/reset_password"
            children={
              <AuthGuard
                unauthorizedComponent={ResetPwd}
                authorizedComponent={<Redirect to="/" />}
              />
            }
          />
        </Switch>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.tsx